import { withAuth } from './';
import { SET_CURRENT_TAB_INDEX, SET_PMREQAESERV_PROJ_ID,
  SET_AELOOKAESERV_PROJ_ID, FETCH_lkp_QueueType_AE_FULFILLED, FETCH_lkp_StatusTracking_AE_FULFILLED, 
  FETCH_lkp_Phase_AE_FULFILLED, FETCH_AE_SEARCH_RESULTS, FETCH_lkp_ProjectProgramType, 
  FETCH_lkp_ProjectType, FETCH_lkp_ProjectTypeForPb, FETCH_ProjectType, POST_PROJECT_TYPES,
  FETCH_DELAYS_GAINS, FETCH_DELAY_ATTTRIBUTED_TOS, FETCH_DELAY_PHASE_OF_OCCURRENCE, FETCH_DELAY_CATEGORY, FETCH_DELAY_SUBCATEGORY, FETCH_lkp_Complexity, FETCH_lkp_LeedCertification, FETCH_ComplexityAnswers, POST_ComplexityAnswers} from '../actions/types';

export function dispatchWithAuth (dispatch, method='get') {
	return (args, type) => {
		withAuth(
      {method, ...args},
      (resp) => dispatch({type: type, payload: resp})
    );
	}
}

export function fetchCostModule (id) {
	const url = `/projects/${id}/costModules`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_COST_MODULE_FULFILLED')
}

export function fetchObjectCodeFMS (id) {
	const url = `/projects/${id}/objectCodeFMS`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_OBJECT_CODE_FMS_FULFILLED')
}

export function fetchDocumentChecklist (id) {
	const url = `/projects/${id}/documentChecklist`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_DOCUMENT_CHECKLIST_FULFILLED')
}

export function fetchlkp_DocumentChecklists () {
	const url = '/projects/lkp_DocumentChecklists';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_DOCUMENT_CHECKLISTs_FULFILLED')
}

export function fetchDocumentChkList_Logs (id) {
	const url = `/projects/${id}/documentChkList_Logs`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_DOCUMENT_CHKLIST_LOGs_FULFILLED')
}

export function fetchClientAgenycTitles (id) {
	const url = `/projects/${id}/clientAgencyTitles`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CLIENT_AGENCY_TITLES_FULFILLED')
}

export function fetchClientAgencies (id) {
	const url = `/projects/${id}/clientAgencies`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CLIENT_AGENCIES_FULFILLED')
}

export function fetch_lkp_ProjectProgramType () {
	const url = '/projects/lkp_ProjectProgramType';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_ProjectProgramType)
}

export function fetch_lkp_ProjectType () {
	const url = '/projects/lkp_ProjectType';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_ProjectType)
}

export function fetch_lkp_ProjectTypeForPb () {
	const url = '/projects/lkp_ProjectTypeForPb';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_ProjectTypeForPb)
}

export function fetchProjectType (id) {
	const url = `/projects/${id}/ProjectTypes`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_ProjectType)
}

//Delay Log dropdowns start
export function fetch_lkp_DelaysGains () {
	const url = '/projects/delayLogs/delaysGains';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_DELAYS_GAINS)
}

export function fetch_lkp_DelayPhaseOfOccurrence () {
	const url = '/projects/delayLogs/phasesOfOccurrence';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_DELAY_PHASE_OF_OCCURRENCE)
}

export function fetch_lkp_DelayCategory () {
	const url = '/projects/delayLogs/categories';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_DELAY_CATEGORY)
}

export function fetch_lkp_DelaySubcategory () {
	const url = '/projects/delayLogs/subcategories';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_DELAY_SUBCATEGORY)
}

export function fetch_lkp_DelayAttributedTos () {
	const url = '/projects/delayLogs/attributedTo';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_DELAY_ATTTRIBUTED_TOS)
}

//Delay Log dropdowns end

//Project complexity start
export function fetch_lkp_Complexity (id) {
	const url = `/projects/${id}/lkp_Complexity`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_Complexity)
}

export function fetch_lkp_LeedCertification () {
	const url = '/projects/lkp_LeedCertification';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_LeedCertification)
}

export function fetchComplexityAnswers (id) {
	const url = `/projects/${id}/ComplexityAnswers`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_ComplexityAnswers)
}

export function postComplexityAnswers(params) {
	const url = `/projects/${params.id}/ComplexityAnswers`;
	const method = 'post';

	return dispatch => {
		dispatch({ type: POST_ComplexityAnswers, payload: params })

		withAuth(
            {method, url, data: params},
            () => {params.onPostPostComplexityAnswers()}
        );
	}
}
//Project complexity end

  //export function postTracking_AE(params) {
export function postProjectTypes(params) {
	const url = `/projects/${params.id}/ProjectTypes`;
	const method = 'post';

	return dispatch => {
		dispatch({ type: POST_PROJECT_TYPES, payload: params })

		withAuth(
            {method, url, data: params},
            () => {params.onPostProjectTypes()}
        );
	}
}

  // AE actions START
export function fetch_lkp_DesignSource_AE () {
	const url = '/projects/lkp_DesignSource_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_DesignSource_AE_FULFILLED')
}

export function fetch_lkp_Discipline_AE () {
	const url = '/projects/lkp_Discipline_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_Discipline_AE_FULFILLED')
}

export function fetch_lkp_JobType_AE () {
	const url = '/projects/lkp_JobType_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_JobType_AE_FULFILLED')
}

export function fetch_lkp_QueueType_AE () {
	const url = '/projects/lkp_QueueType_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_QueueType_AE_FULFILLED)
}

export function fetch_lkp_StatusTracking_AE () {
	const url = '/projects/lkp_StatusTracking_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_StatusTracking_AE_FULFILLED)
}

export function fetch_lkp_Studio_AE () {
	const url = '/projects/lkp_Studio_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_Studio_AE_FULFILLED')
}

export function fetch_lkp_Phase_AE () {
	const url = '/projects/lkp_Phase_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, FETCH_lkp_Phase_AE_FULFILLED)
}

export function fetch_lkp_Track_AE () {
	const url = '/projects/lkp_Track_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_Track_AE_FULFILLED')
}

export function fetch_lkp_ReviewStatus_AE () {
	const url = '/projects/lkp_ReviewStatus_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_ReviewStatus_AE_FULFILLED')
}

export function fetch_lkp_ReviewPhaseStatus_AE (projectId) {
	const url = `/projects/${projectId}/lkp_ReviewPhaseStatus_AE`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_lkp_ReviewPhaseStatus_AE_FULFILLED')
}

export function fetchTrackingPhase_AE (id) {
	const url = `/projects/${id}/TrackingPhase_AE`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_TRACKING_PHASE_AE_FULFILLED')
}

export function fetchTeamLeaders_AE (query) {
	const url = '/projects/teamLeaders_AE';
	const params = { query };
	return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_TEAM_LEADERS_AE_FULFILLED')
}

export function fetchInternalTeam (query) {
	const url = '/projects/internalTeamSearch';
	const params = { query };
	return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_INTERNAL_TEAM_FULFILLED')
}

export function fetchExternalTeam(query) {
	const url = '/projects/externalTeamSearch';
	const params = { query };
	return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_EXTERNAL_TEAM_FULFILLED')
}

export function fetchOtherDiscMembers_AE (query) {
	const url = '/projects/otherDisciplineMembers_AE';
	const params = { query };
	return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_OTHER_MEMBERS_AE_FULFILLED')
}

export function fetchTrackingMembers_AE (id) {
	const url = `/projects/${id}/TrackingMembers_AE`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_TRACKING_MEMBERS_AE_FULFILLED')
}

export function fetchAllMembers_AE () {
	const url = '/projects/allMembers_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_ALL_MEMBERS_AE_FULFILLED')
}

export function getAETrackingByProjectId (id) {
	const url = `/projects/${id}/AETracking`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'GET_AE_TRACKING_BY_PROJECTId')
}

export function fetchAEprojectsInMyQueue () {
	const url = '/projects/AEprojectsInMyQueue';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'GET_AE_PROJECTS_BY_QUEUE')
}

export function getPmLogByPhaseId_AE (phaseId) {
	const url = `/projects/${phaseId}/PmLogByPhaseId`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'GET_PmLogByPhaseId_AE_FULFILLED')
}

export function getPmLogByProjectId_AE (projectId) {
	const url = `/projects/${projectId}/PmLogByProjectId`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'GET_PmLogByProjectId_AE_FULFILLED')
}

export function getDocTypesAEByPhaseId (phaseId) {
	const url = `/projects/${phaseId}/DocumentTypes_AE`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'GET_DOC_TYPES_BY_PHASEID_AE')
}

export function getDocsByProjectId (projectId) {
	const url = `/projects/${projectId}/Documents_AE`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'GET_DOC_BY_PROJECTID_AE')
}

export function fetchAESearchResults_AE (params) {
	let url, method;
	method = 'post';
	url = `/projects/aesearchresults/?skip=${params.skip}`;
    
	return dispatch => {
		dispatch({ type: 'SET_PROJECTS_LOADING', payload: true })

		withAuth(
        {method, url, data: params.data},
        (resp) => {
			resp.data.currentPage = params.currentPage;
			dispatch({type: FETCH_AE_SEARCH_RESULTS, payload: resp});
			dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
		},
		(error) => {
			dispatch({ type: 'FETCH_AE_SEARCH_RESULTS_FAILED', payload: error });
			dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
		}
      );
	}
}

export function fetchMembersForStudio (studioId) {
	const url = `/projects/${studioId}/studioMembers_AE`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_MEMBERS_FOR_STUDIO_FULFILLED')
}

export function fetchMembersNoStudio() {
	const url = '/projects/MembersNoStudio_AE';
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_MEMBERS_NO_STUDIO_AE_FULFILLED')
}

export function showSelectedProject(projectId) {
	const url = `/projects/${projectId}/ShowSelectedProject`;
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'SHOW_SELECTED_PROJECT_AE')
}
  // AE actions END


export function setCurrentTabIndex (currentTabIndex=0) {
	return {
		type: SET_CURRENT_TAB_INDEX,
		currentTabIndex
	}
}

export function setPMReqAEServProjId(pmReqAEServProjId) {
	return {
		type: SET_PMREQAESERV_PROJ_ID,
		pmReqAEServProjId
	}
}

export function setAELookAEServProjId(aeLookAEServProjId) {
	return {
		type: SET_AELOOKAESERV_PROJ_ID,
		aeLookAEServProjId
	}
}

//   Procurement Details START
export function fetchPaymentDetails (id, cntrctId) { 
	const url = `/projects/${id}/paymentdetails/${cntrctId}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_PAYMENTS')
}

export function fetchChangeOrderDetails (id, cntrctId) {   
	const url = `/projects/${id}/changeOrderDetail/${cntrctId}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_CHANGE_ORDERS')
}

export function fetchCSBDetails (id, cntrctId) {  
	const url = `/projects/${id}/csbDetails/${cntrctId}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_CSB_DETAILS')
}

export function fetchFundingSourceDetails (id, cntrctId) {  
	const url = `/projects/${id}/fundingSourceDetails/${cntrctId}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_FS_DETAILS')
}

export function fetchContractManagementDetails (id, cntrctId) {  
	const url = `/projects/${id}/contractManagementDetails/${cntrctId}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_CM_DETAILS')
}

export function fetchTaskOrderDetails (id, cntrctId) {  
	const url = `/projects/${id}/taskOrderDetail/${cntrctId}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_TO_DETAILS')
}

export function fetchSTODetails (id, cntrctId, toNO) {  
	const url = `/projects/${id}/supplementalTaskOrderDetail/${cntrctId}/${toNO}`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACT_STO_DETAILS')
}

export function fetchCPTrackDetails (id) {   
	const url = `/projects/${id}/CPTrackDetail`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CPTRACK_DETAILS')
}
export function fetchProjectPaymentDetails (id) { 
	const url = `/projects/${id}/prjpaymentdetails`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_PROJECT_PAYMENTS')
}
export function fetchProjectContractDetails (id) { 
	const url = `/projects/${id}/contractsdata`; 
	return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_PROJECT_CONTRACT_DATA')
}
//   Procurement Details END
